import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import './App.css';

function Failed() {
  const navigate = useNavigate();

  return (
    <div className="App">
      <Header />
      <div className="container">
        <div className="card">
          <div className="card-header">
            <h1>❌ Ошибка оплаты</h1>
            <p className="subtitle">Платеж не был завершен. Попробуйте еще раз</p>
          </div>
          <button 
            className="payment-btn sbp-btn" 
            onClick={() => navigate('/')}
            style={{ marginTop: '20px' }}
          >
            Вернуться на главную
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Failed;

